module.exports = __webpack_public_path__ + "img/th.17e1ff82.svg";